// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.demo-ruleForm[data-v-961cceae] .el-form-item__error {\n  position: static !important;\n}\n.tas[data-v-961cceae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.tas .label[data-v-961cceae] {\n  width: 150px;\n  padding-right: 10px;\n  text-align: end;\n}\n", ""]);
// Exports
module.exports = exports;
